import { getSectionHeadingPath } from '/src/utils/apiFunctions';
import httpClient from '/src/utils/httpClient';
import { pathTypes } from '/src/utils/sectionEnums';

export function updateMapApiCall({
  id,
  isPathDesign,

  mapCode,

  headingTitle,
  headingDescription,
  headingTextAlign,
  headingImage,
  headingDivider,

  sectionBorderColor,
  sectionIsBackground,
  sectionTextColor,
  sectionBackgroundColor,
  sectionOpacity,
  sectionMargin,
  sectionPadding,
  sectionIsFullWidth,
  sectionShadow,
  sectionShadowColor,
  sectionShadowBorderColor,
  sectionShape,
  sectionBackgroundType,
  sectionBackgroundImage,
  sectionGradientColor1,
  sectionGradientColor2,
  sectionGradientDirection,
  sectionGradientOffset,
  sectionBorder,

  buttonText,
  buttonOpacity,
  buttonBackgroundColor,
  buttonTextColor,
  buttonBorder,
  buttonBorderColor,
  buttonShadow,
  buttonShadowColor,
  buttonShape,

  itemShadow,
  itemShadowColor,
  itemShape,
  itemBorder,
  itemBorderColor,
  itemTextColor,
  itemBackgroundColor,

  mapAddress,
  mapAddressLink,
  addressButtonText,
  addressIconType,
  addressTitle,
  mapView,
  addressList,
}) {
  return httpClient.put(getSectionHeadingPath(pathTypes.map, isPathDesign, id), {
    id,

    mapCode,

    headingTitle,
    headingDescription,
    headingTextAlign,
    headingImage,
    headingDivider,

    sectionBorderColor,
    sectionIsBackground,
    sectionTextColor,
    sectionBackgroundColor,
    sectionOpacity,
    sectionMargin,
    sectionPadding,
    sectionIsFullWidth,
    sectionShadow,
    sectionShadowColor,
    sectionShadowBorderColor,
    sectionShape,
    sectionBackgroundType,
    sectionBackgroundImage,
    sectionGradientColor1,
    sectionGradientColor2,
    sectionGradientDirection,
    sectionGradientOffset,
    sectionBorder,

    buttonText,
    buttonOpacity,
    buttonBackgroundColor,
    buttonTextColor,
    buttonBorder,
    buttonBorderColor,
    buttonShadow,
    buttonShadowColor,
    buttonShape,

    itemShadow,
    itemShadowColor,
    itemShape,
    itemBorder,
    itemBorderColor,
    itemTextColor,
    itemBackgroundColor,

    address: mapAddress,
    addressUrl: mapAddressLink,
    directionButtonText: addressButtonText,
    directionButtonType: addressIconType,
    addressTitle,
    view: mapView,
    items: addressList,
  });
}
